<template>
    <div>
        <div class="input-group">
            <label for="Ajet-api-url">Ajet API URL:</label>
            <input id="Ajet-api-url" type="text" v-model="ApiURL" placeholder="Ajet API URL girin" />
        </div>
        <div class="input-group">
            <label for="Ajet-username">Ajet Username:</label>
            <input id="Ajet-username" type="text" v-model="Username" placeholder="Ajet Username girin" />
        </div>
        <div class="input-group">
            <label for="Ajet-password">Ajet Password:</label>
            <input id="Ajet-password" type="text" v-model="Password" placeholder="Ajet Password girin" />
        </div>
        <div class="input-group">
            <label for="Ajet-invoice">Ajet Invoice:</label>
            <input id="Ajet-invoice" type="text" v-model="Invoice" placeholder="Ajet Invoice girin" />
        </div>
        <v-btn color="primary" class="mt-4" @click="saveProviderConfig">
            Kaydet
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "AjetProvider",
    props: {
        providerData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            ApiURL: "",
            Username: "",
            Password: "",
            Invoice: "",
        }
    },
    watch: {
        // Üst bileşenden (Parent) gelen veriyi izler ve formu günceller
        providerData: {
            handler(newValue) {
                this.fillForm(newValue);
            },
            deep: true,
            immediate: true // İlk yüklemede boş veya dolu gelme durumunu yakalar
        }
    },
    methods: {
        fillForm(data) {
            // veri var ve içi doluysa form alanlarını doldurur
            if (data && Object.keys(data).length > 0) {
                this.ApiURL = data.Address || data.url || "";
                this.Username = data.ServiceUsername || data.username || "";
                this.Password = data.ServicePassword || data.password || "";
                this.Invoice = data.ServiceSecurityKey || data.invoice || "";

            } else {
                // veri boş veya null geldiyse form alanlarını temizler
                this.ApiURL = "";
                this.Username = "";
                this.Password = "";
                this.Invoice = "";
            }
        },
        saveProviderConfig() {
            if (!this.ApiURL || !this.Username || !this.Password || !this.Invoice)
                return this.$toast.error("Lütfen tüm alanları doldurun.");

            // Gelen datada ID kontrolüne göre add/edit modu belirlenir
            const type = this.providerData && this.providerData.Id ? 'edit' : 'add';

            const config = {
                Address: this.ApiURL,
                ServiceUsername: this.Username,
                ServicePassword: this.Password,
                ServiceSecurityKey: this.Invoice,
            }
            this.$emit("save", config, type);
        }
    }
}
</script>

<style scoped>
div {
    font-family: 'Roboto', sans-serif;
}

.input-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.input-group label {
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
}

.input-group input {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.input-group input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.input-group input::placeholder {
    color: #999;
}

.mt-4 {
    margin-top: 16px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}
</style>